<template>
    <div id="app">
        <app-layout v-if="isShow">
            <template slot="main">
                <router-view></router-view>
            </template>
        </app-layout>
    </div>
</template>
<script>
import appLayout from '@/views/components/layout'
import { GetHashValue } from '@/utils'

export default {
  name: 'app',
  components: {
    appLayout
  },
  created () {
    const html = document.documentElement
    const searchLang = GetHashValue('lang')
    const lang = searchLang ||
      this.$i18n.locale ||
      html.getAttribute('lang') ||
      'zh-CN'
    html.setAttribute('lang', lang)
    this.$i18n.locale = lang
  },
  computed: {
    loginUser () {
      return this.$store.state.global.loginInfo
    },
    isShow () {
      if (process.env.VUE_APP_LOGIN_WAY === '1') {
        // 内网登录
        return true
      } else {
        // 外网登录
        return this.loginUser
      }
    }
  },
  watch: {
    '$i18n.locale': {
      handler (val) {
        if (GetHashValue('lang')) {
          window.location.assign(window.location.href.replace(
            /(lang)=[^&]*/,
            `$1=${val}`
          ))
        }
        document.documentElement.setAttribute('lang', val)
      },
      immediate: true
    }
  }
}

</script>
